jQuery(document).ready(function ($) {

    $('.editor img').each(function () {
        $(this).parent().addClass('editor__image');
        if ($(this).hasClass('aligncenter')) {
            $(this).parent().addClass('editor__image--align-center');
        } else if ($(this).hasClass('alignright')) {
            $(this).parent().addClass('editor__image--align-right');
        }
    });

    $('.read-more__link').on('click', function (e) {
        e.preventDefault();
        $(this).parent().parent().find('.read-more__content').slideToggle();
    });

});
